import { Component } from 'preact'
import { formatPrice } from 'lib/textHelper'

import { Caption } from '../../textNodes'

export default class NewPaybarFooterCaptionVacancy extends Component {
  get price() {
    return this.props.prices.oneTime
  }

  get captionText() {
    const price = formatPrice(this.price)

    return I18n.t('newPaybar.submitButtonCaption.vacancy.self', { price })
  }

  render() {
    return (
      <Caption html={ this.captionText } />
    )
  }
}
